export default {"src":"/_next/static/media/post-address.0da93f41.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};